import { dealDamage, addModifier } from '../player.type';
import type { Die } from '../die.type';
import type { Technique } from '../techniques.type';
import type { Player } from '../player.type';
import { StatusEffect } from '../status-effects.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';

export const claws: Technique[] = [
  {
    ingredients: [DieFace.Claws],
    title: 'Claw',
    text: 'Deal 1 Damage',
    tags: ['damage'],
    audio: SoundType.AttackRend,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 1, target, source, dice });
    },
  },
  {
    ingredients: [DieFace.Claws, DieFace.Claws],
    title: 'Scratch',
    text: 'Deal 2 Damage, Apply 1 Bleed.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackRend,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Bleed, 1);
    },
  },
  {
    ingredients: [DieFace.Claws, DieFace.Claws, DieFace.Claws],
    title: 'Scratchfest',
    text: 'Deal 4 Damage, Apply 2 Bleed.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackRend,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 4, target, source, dice });
      addModifier(target, StatusEffect.Bleed, 2);
    },
  },
  {
    ingredients: [DieFace.Claws, DieFace.Agility],
    title: 'Pounce',
    text: 'Deal 2 Damage, Gain 1 dodge',
    tags: ['damage', 'defence'],
    audio: SoundType.AttackRend,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(source, StatusEffect.Dodge, 1);
    },
  },
  {
    ingredients: [DieFace.Claws, DieFace.Bite],
    title: 'Rip & Tear',
    text: 'Deal 2 Damage, Apply 2 Bleed.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackRend,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Bleed, 2);
    },
  },
];
